import { IPermission } from '../interfaces/global';
import { fetchPermissions } from '../services/services';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useCancelQueries = () => {
  const queryClient = useQueryClient();
  const cancelQueries = async (name: string) => await queryClient.cancelQueries([name]);
  const invalidateQueries = async (name: string) => await queryClient.invalidateQueries([name]);
  const resetQueries = async (name: string) => await queryClient.resetQueries([name]);
  const removeQueries = async (name: [string, number]) => await queryClient.removeQueries([name]);
  return { cancelQueries, invalidateQueries, resetQueries, removeQueries };
};

export const useQueryPermission = () => {
  const { ...queryPermission } = useQuery<IPermission[]>(['useQueryPermission'], fetchPermissions);
  return queryPermission;
};
